import { createContext } from 'react'
import { mineralsInitialState } from './mineralsInitialState'

const MineralsContext = createContext(mineralsInitialState)

export default MineralsContext
